import { useMemo } from 'react'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { env } from 'admin/lib/config/env-config.js'

export function useAppInsights() {
  return useMemo(() => {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: env.NX_APPINSIGHTS_CONN_STR
      }
    })
    appInsights.loadAppInsights()
    appInsights.trackPageView()
    return appInsights
  }, [])
}
